import React, { useEffect, useState } from 'react';

import { useInterval } from '../hooks';
import { getTimeFromSeconds, getSecondsFromPrevTime, formatTimerValues } from '../utils/time.js';


const Timer = ( { startTime } ) => {
    const [ secondsPassed, setSecondsPassed ] = useState( 0 );

    useEffect( () => {
        setSecondsPassed( getSecondsFromPrevTime( startTime || 0 ) );
    }, [ startTime ] );

    useInterval( () => {
        setSecondsPassed( getSecondsFromPrevTime( startTime || 0 ) );
    }, 1000 );

    const { hours, minutes, seconds } = getTimeFromSeconds( secondsPassed );
    const timeString = formatTimerValues( { hours, minutes, seconds } );

    return (
        <>
            <span>{ timeString }</span>
        </>
    );

};
export default Timer;